<main fxLayout="column" fxFlex="auto" class="main">
  <router-outlet #o="outlet"></router-outlet>
</main>
